module.exports = __webpack_public_path__ + "static/media/sad-face.c4bb98dd.svg";